import { Typography } from '@material-ui/core';
import clsx from 'clsx';
import { format, parseISO } from 'date-fns';

import { IndicatorEventDay } from 'generated';

import { useStyles } from './styles';

interface DaysRenderProps {
  days: IndicatorEventDay[];
}

const dateFormat = 'dd/MM/yy HH:mm';

export function DaysRender({ days }: DaysRenderProps): JSX.Element {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      {days.map(eventDay => (
        <div key={eventDay.day} className={classes.container}>
          <Typography className={classes.dayTitle} variant="subtitle2">
            Dia {eventDay.day}
          </Typography>
          <div className={clsx(classes.row, classes.headRow)}>
            <Typography className={classes.head}>Prova</Typography>
            <Typography className={classes.head}>N° de questões</Typography>
            <Typography className={classes.head}>Início</Typography>
            <Typography className={classes.head}>Término</Typography>
          </div>
          <div className={classes.row}>
            <Typography variant="subtitle2">{eventDay.examName}</Typography>
            <Typography variant="subtitle2">
              {eventDay.numberOfQuestions}
            </Typography>
            <Typography variant="subtitle2">
              {format(parseISO(eventDay.startAt), dateFormat)}
            </Typography>
            <Typography variant="subtitle2">
              {format(parseISO(eventDay.endAt), dateFormat)}
            </Typography>
          </div>
        </div>
      ))}
    </div>
  );
}
